import { Observable } from "rxjs";
import { ApiDataService } from "../shared/services/api.data.service";
import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root'
  })
export class RegistrationService {
    
    constructor(private api: ApiDataService){

    }
    get(code: string, tenantId: string) : Observable<any>{
        const url = this.api.buildBaseUrl(`${tenantId}/registration?code=${code}`);
        return this.api.get(url);
    }
    createNewUser(registration: any, tenantId: string): Observable<any>{
        const url = this.api.buildBaseUrl(`${tenantId}/registration`);
        return this.api.post(url, registration);
    }
    createExistingUser(code: string, tenantId: string): Observable<any> {
      const url = this.api.buildBaseUrl(`${tenantId}/registration`);
        return this.api.post(url, {registrationCode: code });
    }

}